module.exports = __webpack_public_path__ + "img/background4.492e4568.jpg";